import React from 'react';

import { classNames } from '@/helpers/classNames';
import { Capacitor } from '@capacitor/core';

import styles from './ResponsiveBoxButtons.module.scss';

export type ResponsiveBoxButton = {
	content: React.ReactNode;
	label: string;
	selected?: boolean;
	onClick?: (index: number) => void;
};

type ResponsiveBoxButtonsProps = {
	items: ResponsiveBoxButton[];
	className?: string;
	gap?: number; // px
};

const isCapacitor = Capacitor.isNativePlatform();

export const ResponsiveBoxButtons: React.FC<ResponsiveBoxButtonsProps> = ({
	items,
	className,
	gap,
}) => {
	const classes = classNames([styles['root'], className]);

	return (
		<div className={classes}>
			<div className={styles['grid']} style={{ gap: gap || 15 }}>
				{items.map(({ content, label, selected, onClick }, index) => (
					<div
						key={`responsive-box-button-${index}`}
						className={classNames([
							styles['button'],
							selected && styles['selected'],
							!isCapacitor && !selected && styles['hover'],
						])}
						onClick={() => onClick?.(index)}
					>
						<div className={styles['content']}>{content}</div>
						<span className={styles['label']}>{label}</span>
					</div>
				))}
			</div>
		</div>
	);
};
